import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NOTIFICATION_TIMEOUT } from 'constants/index';

import { ComponentType } from 'modules/notifications/types/Notification';

import { removeNotification } from 'modules/notifications/actions';

import { getNotifications } from 'modules/notifications/selectors';

import { createDictionary } from 'utils/objectUtils';

import { Alert, AlertModal } from 'components/ui';

const componentByType = createDictionary({
  [ComponentType.ALERT]: Alert,
  [ComponentType.MODAL]: AlertModal,
}, Alert);

const Notifications: React.FC = () => {
  const dispatch = useDispatch();

  const currentNotifications = useSelector(getNotifications);

  const handleNotificationEnd = React.useCallback(() => dispatch(removeNotification()), [dispatch]);

  return (
    <div className="fixed top-12 right-4 flex flex-col h-max z-50">
      {currentNotifications.map(({
        id, title, description, collapse, type, duration, componentType,
      }) => {
        const Component = componentByType[componentType];
        return (
          <Component
            key={id}
            type={type}
            title={title}
            collapse={collapse}
            description={description}
            onClose={handleNotificationEnd}
            duration={duration ?? NOTIFICATION_TIMEOUT}
          />
        );
      })}
    </div>
  );
};

export default Notifications;
